import { usePrimaryFill } from '../../hooks/usePrimaryFill';
import { useT } from '../../i18n';
import styles from './ConfirmationModal.module.css';

export interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  description: string;
  cancelText?: string;
  confirmText?: string;
  onCancel: () => void;
  onConfirm: () => void;
  primaryColor?: string;
  /** Fill applied on hover of the confirm button */
  primaryHoverColor?: string;
  useGradient?: boolean;
}

export function ConfirmationModal({
  isOpen,
  title,
  description,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  primaryColor,
  primaryHoverColor,
  useGradient = false,
}: ConfirmationModalProps) {
  const t = useT();
  const { style: confirmFillStyle, onMouseEnter, onMouseLeave } = usePrimaryFill(
    primaryColor,
    primaryHoverColor,
    useGradient,
  );

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onCancel}
          >
            {cancelText ?? t('confirm.cancel')}
          </button>
          <button
            type="button"
            className={styles.confirmButton}
            style={confirmFillStyle ? { ...confirmFillStyle, borderColor: primaryColor } : undefined}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onConfirm}
          >
            {confirmText ?? t('confirm.newChat')}
          </button>
        </div>
      </div>
    </div>
  );
}
